<div class="mb-8 flex items-start justify-between gap-4">
  <div class="flex items-center gap-4">
    @if (iconType()) {
      <span class="flex items-center justify-center bg-primary-500 text-white p-2.5 rounded-tl-xl rounded-br-xl">
        <elcia-icon [iconSize]="'2xl'" [iconType]="iconType()"/>
      </span>
    }
    <div class="flex flex-col">
      <h1 [class]="sizeClass()">{{ title() }}</h1>
      @if (subtitle()) {
        <p class="mt-1 text-base text-slate-500">{{ subtitle() }}</p>
      }
    </div>
  </div>
  <div class="flex shrink-0 items-center gap-2">
    <ng-content/>
  </div>
</div>
